import { Link } from "@tanstack/react-router"

export default function CTA() {
  return (
    <section className="flex flex-col items-center gap-8 px-6 py-14 sm:py-20">
      <div className="flex items-center gap-2">
        <div className="h-2 w-2 rounded-full bg-spark-orange" />
        <div className="h-2 w-2 rounded-full bg-spark-purple" />
        <div className="h-2 w-2 rounded-full bg-spark-yellow" />
      </div>
      <Link
        to="/auth"
        className="relative inline-block rounded-[10px] bg-spark-orange px-14 py-4 text-lg font-medium text-white transition-transform before:absolute before:-inset-1.5 before:animate-[cta-pulse_2.5s_ease-in-out_infinite] before:rounded-[14px] before:bg-spark-orange before:opacity-0 hover:scale-[1.02]"
      >
        Sign Up
      </Link>
    </section>
  )
}
